import { without } from 'ramda'
import { Roles } from 'utils/consts/userRoles'
import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

const winesFullOrder = [
  databaseFiltersName.countryFilter,
  databaseFiltersName.producerFilter,
  databaseFiltersName.producerWWLFilter,
  databaseFiltersName.brandFilter,
  databaseFiltersName.additionalNameFilter,
  databaseFiltersName.withAdditionalNameFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.specialClassificationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
  databaseFiltersName.vintageFilter,
  databaseFiltersName.onlyLatestVintageFilter,
  databaseFiltersName.grapesFilter,
  databaseFiltersName.hasBottleImageFilter,
  databaseFiltersName.adminPackshotImageFilter,
  databaseFiltersName.hasFrontLabelImageFilter,
  databaseFiltersName.adminFrontLabelImageFilter,
  databaseFiltersName.hasBackLabelImageFilter,
  databaseFiltersName.adminBackLabelImageFilter,
  databaseFiltersName.bottleSizeFilter,
  databaseFiltersName.packageTypeFilter,
  databaseFiltersName.alcoholLevelFilter,
  databaseFiltersName.certificatesFilter,
  databaseFiltersName.wwlRatingFilter,
  databaseFiltersName.havePublicReviewsFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.checkedByFilter,
]

export const getDatabaseWinesFiltersCollection = (
  role: Role
): FiltersCollection => {
  switch (role) {
    case Roles.PERSON:
      return pickEntries([
        databaseFiltersName.countryFilter,
        databaseFiltersName.producerFilter,
        databaseFiltersName.brandFilter,
        databaseFiltersName.wineRegionEUFilter,
        databaseFiltersName.nationalGITypeFilter,
        databaseFiltersName.geoIndicationFilter,
        databaseFiltersName.specialClassificationFilter,
        databaseFiltersName.wineTypeFilter,
        databaseFiltersName.wineColourFilter,
        databaseFiltersName.sweetnessTypeFilter,
        databaseFiltersName.vintageFilter,
        databaseFiltersName.onlyLatestVintageFilter,
        databaseFiltersName.retailPriceFilter,
        databaseFiltersName.cellarDoorPriceFilter,
        databaseFiltersName.grapesFilter,
        databaseFiltersName.alcoholLevelFilter,
        databaseFiltersName.certificatesFilter,
        databaseFiltersName.bottleSizeFilter,
        databaseFiltersName.packageTypeFilter,
        databaseFiltersName.producerWWLFilter,
        databaseFiltersName.wwlRatingFilter,
        databaseFiltersName.havePublicReviewsFilter,
      ])
    case Roles.CONTENT:
    case Roles.ADMIN:
    case Roles.SUPERADMIN:
      return pickEntries(winesFullOrder)
    case Roles.MANAGER:
      return pickEntries(
        without(
          [
            databaseFiltersName.sourceFilter,
            databaseFiltersName.checkedByFilter,
          ],
          winesFullOrder
        )
      )
    default:
      return pickEntries([
        databaseFiltersName.countryFilter,
        databaseFiltersName.usersFilter,
        databaseFiltersName.sourceFilter,
        databaseFiltersName.creationDateFilter,
        databaseFiltersName.checkedByFilter,
        databaseFiltersName.invalidRecordFilter,
        databaseFiltersName.producerFilter,
        databaseFiltersName.brandFilter,
        databaseFiltersName.euGITypeFilter,
        databaseFiltersName.nationalGITypeFilter,
        databaseFiltersName.wineRegionEUFilter,
        databaseFiltersName.geoIndicationFilter,
        databaseFiltersName.wineTypeFilter,
        databaseFiltersName.wineColourFilter,
        databaseFiltersName.sweetnessTypeFilter,
        databaseFiltersName.vintageFilter,
        databaseFiltersName.bottleSizeFilter,
        databaseFiltersName.packageTypeFilter,
        databaseFiltersName.grapesFilter,
        databaseFiltersName.certificatesFilter,
        databaseFiltersName.wwlRatingFilter,
      ])
  }
}

export const databaseWinesFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseWinesFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
